/**
 * Client-visible unlock metadata for portfolio media (music, video, newsletters, etc.).
 */
export interface PortfolioMediaUnlockedThrough {
  is_unlocked?: boolean;
  is_outer_unlocked?: boolean;
  locked_by_album?: boolean;
}

export function mergePortfolioMediaUnlockedThrough(
  base: PortfolioMediaUnlockedThrough | undefined,
  patch: Partial<PortfolioMediaUnlockedThrough>
): PortfolioMediaUnlockedThrough {
  return { ...(base ?? {}), ...patch };
}
